import { render, staticRenderFns } from "./PaymentForm.vue?vue&type=template&id=be0c5cd2&scoped=true&"
import script from "./PaymentForm.vue?vue&type=script&lang=js&"
export * from "./PaymentForm.vue?vue&type=script&lang=js&"
import style0 from "./PaymentForm.vue?vue&type=style&index=0&id=be0c5cd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0c5cd2",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/payment_form.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fbasket%2FPaymentForm.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports